const articleHeroMapping = (data) => {
  const mappedData = {};

  mappedData.desktopImage = {
    url: data.field_desktop_img[0]?.url,
    alt: data.field_desktop_img[0]?.alt
  }
  mappedData.tabletImage = {
    url: data.field_tablet_img[0]?.url,
    alt: data.field_tablet_img[0]?.alt
  }
  mappedData.mobileImage = {
    url: data.field_mobile_img[0]?.url,
    alt: data.field_mobile_img[0]?.alt
  }

  return mappedData;
}

export default articleHeroMapping;
